import { flinkIcons } from './icons/flink';
import { ihzIcons } from './icons/ihz';

// define the flinkIcons to be the base icons
const baseIcons = [...flinkIcons];
export type baseIcon = (typeof baseIcons)[number];

export const ihzIconSet: baseIcon[] = ihzIcons;
export const flinkIconSet: baseIcon[] = flinkIcons;
